module.exports = __webpack_public_path__ + "assets/71f53bac55cf1f24fd9975926ea771c8.png";